import OfferCard from '@/app-theme/views/home/OfferCard.vue'

export default {
  name      : 'OfferSlider',
  components: {
    OfferCard
  },
  directives: {},
  mixins    : [],
  props     : {
    title: {
      type   : String,
      default: function () {
        return this.$tc('Offer.Title', 0)
      }
    },


    titleClass: {
      type   : String,
      default: 'text-sm-h5 text-body-1 font-weight-bold'
    },

    offers: {
      type   : Array,
      default: () => []
    }
  },
  enums: {},
  data() {
    return {
      hasPrev: false,
      hasNext: false
    }
  },
  computed: {
    cardWidth() {
      if (this.$vuetify.breakpoint.xs) return 200
      if (this.$vuetify.breakpoint.sm) return 300
      if (this.$vuetify.breakpoint.md) return 350
      if (this.$vuetify.breakpoint.lg) return 450

      return 500
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    this.$watch(() => this.$refs.offersSlideGroup.hasPrev, (newValue) => {
      this.hasPrev = newValue
    })
    this.$watch(() => this.$refs.offersSlideGroup.hasNext, (newValue) => {
      this.hasNext = newValue
    })
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    /**
     * onAffixClick
     *
     * @param location {String}
     */
    onAffixClick(location) {
      this.$refs.offersSlideGroup.onAffixClick(location)
    }
  }
}
